import React, { useEffect, useState } from 'react'
import { Col, Row, Table } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'
import DeleteIcon from '../../../components/AllSvgIcon/DeleteIcon'
import EditIcon from '../../../components/AllSvgIcon/EditIcon'
import Loader from '../../../components/Loader'
import ModelComponent from '../../../components/Modal'
import CustomToast from '../../../components/Toast/CustomToast'
import { customStyles } from '../../../components/customStyles'
import {
  calculatePageRange,
  encodeId,
  showToast
} from '../../../lib/AllGlobalFunction'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import { pageRangeDisplayed } from '../../../lib/AllStaticVariables'
import axiosProvider from '../../../lib/AxiosProvider'
import { _SwalDelete, _exception } from '../../../lib/exceptionMessage'
import NotFound from '../../NotFound/NotFound'
import { setPageTitle } from '../../redux/slice/pageTitleSlice'

const AssignCategory = () => {
  const navigate = useNavigate()
  const [categoriesToShowInList, setCategoriesToShowInList] = useState([])
  const [data, setData] = useState()
  const [modalSizeShow, setSizeModalShow] = useState(false)
  const [modalAttributesShow, setAttributesModalShow] = useState(false)
  const [modalSpecificationShow, setSpecificationModalShow] = useState(false)
  const [specSpecificationData, setSpecSpecificationData] = useState()
  const [attributesModalData, setAttributesModalData] = useState()
  const [sizeSpecificationData, setSizeSpecificationData] = useState()
  const [SpecificationData, setSpecificationData] = useState()
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })
  const dispatch = useDispatch()
  const { userInfo, pageAccess } = useSelector((state) => state.user)
  const [filterDetails, setFilterDetails] = useImmer({
    pageSize: 50,
    pageIndex: 1,
    catId: ''
  })

  const getUniqueListBy = (arr, key) => {
    return [...new Map(arr.map((item) => [item[key], item])).values()]
  }

  const handlePageClick = (event) => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setFilterDetails((draft) => {
      draft.pageIndex = event.selected + 1
    })
  }

  const handleDelete = async (id) => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'DELETE',
        endpoint: 'AssignSpecificationToCategory',
        queryString: `?Id=${id}`,
        userId: userInfo?.userId,
        location: location.pathname
      })
      setLoading(false)
      if (response?.data?.code === 200) {
        fetchData()
      }
      showToast(toast, setToast, response)
    } catch {
      setLoading(false)

      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  const fetchSpecSpecificationData = async (id) => {
    const response = await axiosProvider({
      method: 'GET',
      endpoint: 'AssignSpecValuesToCategory/byAssignSpecID',
      queryString: `?assignSpecId=${id}`
    })
      .then((res) => {
        if (res.status === 200) {
          setSpecSpecificationData(res?.data?.data)
        } else {
          setSizeSpecificationData(null)
        }
      })
      .catch((err) => {
        alert(err)
      })
  }

  const fetchSizeSpecificationData = async (data) => {
    setLoading(true)
    const response = await axiosProvider({
      method: 'GET',
      endpoint: 'AssignSizeValuesToCategory/ByAssignSpecId',
      queryString: `?AssignSpecID=${data?.id}&PageIndex=0&PageSize=0`
    })
    setLoading(false)

    if (response?.data?.code === 200) {
      let tempArr = response?.data?.data
      let emptyArr = []
      tempArr.map((x) => {
        if (emptyArr.length > 0) {
          emptyArr.map((y) => {
            if (y.sizeTypeID === x.sizeTypeID) {
              let newData = {
                ...y,
                sizeName: `${y.sizeName}, ${x.sizeName}`
              }
              emptyArr.push({
                ...newData,
                isAllowPriceVariant: data?.isAllowPriceVariant
              })
            } else {
              emptyArr.push({
                ...x,
                isAllowPriceVariant: data?.isAllowPriceVariant
              })
            }
          })
        } else {
          emptyArr.push({
            ...x,
            isAllowPriceVariant: data?.isAllowPriceVariant
          })
        }
      })

      emptyArr = getUniqueListBy(emptyArr, 'sizeTypeID')

      setSizeSpecificationData(emptyArr)
      setSizeModalShow(true)
    } else {
      setSizeSpecificationData(null)
      showToast(toast, setToast, {
        data: {
          message: response?.data?.message,
          code: 204
        }
      })
      setSizeModalShow(false)
    }
  }

  const fetchData = async () => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'GET',
        endpoint: filterDetails?.catId
          ? 'AssignSpecificationToCategory/getListByCatId'
          : 'AssignSpecificationToCategory',
        queryString: filterDetails?.catId
          ? `?catId=${filterDetails?.catId}`
          : `?pageIndex=${filterDetails?.pageIndex}&pageSize=${filterDetails?.pageSize}`
      })
      setLoading(false)
      if (response?.status === 200) {
        setData(response)

        if (!categoriesToShowInList?.length) {
          const response = await axiosProvider({
            method: 'GET',
            endpoint: 'SubCategory/search',
            queryString: `?pageindex=0&PageSize=0`
          })

          if (response?.status === 200) {
            setCategoriesToShowInList(response?.data?.data)
          }
        }
      }
    } catch {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filterDetails])

  useEffect(() => {
    dispatch(setPageTitle('Assign Attributes'))
  }, [])

  return checkPageAccess(
    pageAccess,
    allPages?.assignAttributes,
    allCrudNames?.read
  ) ? (
    <>
      <div className='card'>
        <div className='card-body'>
          <Row className='justify-content-between align-items-center'>
            <Col md={5}>
              <div className='d-flex align-items-center gap-3'>
                <div className='input-select-wrapper flex-fill'>
                  <Select
                    menuPortalTarget={document.body}
                    styles={customStyles}
                    isClearable={true}
                    menuPosition={'fixed'}
                    options={categoriesToShowInList?.map(
                      ({ id, pathNames }) => ({
                        label: pathNames,
                        value: id
                      })
                    )}
                    onChange={(e) => {
                      setFilterDetails((draft) => {
                        draft.catId = e?.value ?? ''
                      })
                    }}
                    placeholder={'Select Categories'}
                  />
                </div>

                <div className='d-flex align-items-center'>
                  <label className='me-1'>Show</label>
                  <select
                    name='dataget'
                    id='parpageentries'
                    className='form-select me-1'
                    onChange={(e) => {
                      setFilterDetails((draft) => {
                        draft.pageSize = e?.target?.value
                        draft.pageIndex = 1
                      })
                    }}
                  >
                    <option value='10'>10</option>
                    <option value='25'>25</option>
                    <option value='50'>50</option>
                    <option value='100'>100</option>
                    <option value='200'>200</option>
                    <option value='500'>500</option>
                  </select>
                </div>

                <div className='page-range'>
                  {calculatePageRange({
                    ...filterDetails,
                    recordCount: data?.data?.pagination?.recordCount ?? 0
                  })}
                </div>
              </div>
            </Col>
            <Col md={2} className='text-end'>
              {checkPageAccess(
                pageAccess,
                allPages?.assignAttributes,
                allCrudNames?.write
              ) && (
                <Link
                  className='btn btn-warning d-inline-flex align-items-center gap-2 fw-semibold'
                  to='/category/assign-category/manage-filter'
                >
                  <i className='m-icon m-icon--plusblack'></i>
                  Create Attributes
                </Link>
              )}
            </Col>
          </Row>
        </div>
      </div>

      {toast?.show && (
        <CustomToast text={toast?.text} variation={toast?.variation} />
      )}

      {loading && <Loader />}

      <div className='card'>
        <div className='card-body'>
          <Table responsive className='align-middle table-list'>
            <thead>
              <tr>
                <th>Categories</th>
                <th className='text-center'>Size</th>
                <th className='text-center'>Attributes</th>
                <th className='text-center'>Specification</th>
                {checkPageAccess(pageAccess, allPages?.assignAttributes, [
                  allCrudNames?.update,
                  allCrudNames?.delete
                ]) && <th className='text-center'>Action</th>}
              </tr>
            </thead>
            <tbody>
              {data?.data?.data?.length > 0 ? (
                data?.data?.data?.map((category) => (
                  <tr key={category.id}>
                    <td>
                      {' '}
                      <div>
                        <p className='fw-bold mb-1'>{category.categoryName}</p>
                        <small>{category.categoryPathNames}</small>
                        <p>
                          <small>
                            Price Variant:{' '}
                            {category.isAllowPriceVariant ? 'Yes' : 'No'}
                          </small>
                        </p>
                      </div>
                    </td>
                    <td className='text-center'>
                      {category.isAllowSize ? (
                        <button
                          className='btn btn-ct-size'
                          onClick={() => {
                            fetchSizeSpecificationData(category)
                          }}
                        >
                          Size
                        </button>
                      ) : (
                        <button className='btn btn-outline-secondary disabled'>
                          Size
                        </button>
                      )}
                    </td>
                    <td className='text-center'>
                      {category.isAllowColors ? (
                        <button
                          className='btn btn-ct-specification'
                          onClick={() => {
                            setAttributesModalData(category)
                            setAttributesModalShow(true)
                          }}
                        >
                          Attributes
                        </button>
                      ) : (
                        <button className='btn btn-outline-secondary disabled'>
                          Attributes
                        </button>
                      )}
                    </td>
                    <td className='text-center'>
                      {category.isAllowSpecifications ? (
                        <button
                          className='btn spec-btn'
                          onClick={() => {
                            fetchSpecSpecificationData(category.id)
                            setSpecificationModalShow(true)
                          }}
                        >
                          Specification
                        </button>
                      ) : (
                        <button className='btn btn-outline-secondary disabled'>
                          Specification
                        </button>
                      )}
                    </td>
                    {checkPageAccess(pageAccess, allPages?.assignAttributes, [
                      allCrudNames?.update,
                      allCrudNames?.delete
                    ]) && (
                      <td className='text-center'>
                        <div className='d-flex gap-2 justify-content-center'>
                          {checkPageAccess(
                            pageAccess,
                            allPages?.assignAttributes,
                            allCrudNames?.update
                          ) && (
                            <span
                              onClick={() => {
                                navigate(
                                  `/category/assign-category/manage-filter?id=${encodeId(
                                    category.id
                                  )}`
                                )
                              }}
                            >
                              <EditIcon bg={'bg'} />
                            </span>
                          )}
                          {checkPageAccess(
                            pageAccess,
                            allPages?.assignAttributes,
                            allCrudNames?.delete
                          ) && (
                            <span
                              onClick={() => {
                                Swal.fire({
                                  title: _SwalDelete.title,
                                  text: _SwalDelete.text,
                                  icon: _SwalDelete.icon,
                                  showCancelButton:
                                    _SwalDelete.showCancelButton,
                                  confirmButtonColor:
                                    _SwalDelete.confirmButtonColor,
                                  cancelButtonColor:
                                    _SwalDelete.cancelButtonColor,
                                  confirmButtonText:
                                    _SwalDelete.confirmButtonText,
                                  cancelButtonText: _SwalDelete.cancelButtonText
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    handleDelete(category.id)
                                  } else if (result.isDenied) {
                                  }
                                })
                              }}
                            >
                              <DeleteIcon bg={'bg'} />
                            </span>
                          )}
                        </div>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className='text-center'>
                    {data?.data?.message}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {data?.data?.pagination?.pageCount > 0 && (
            <ReactPaginate
              className='list-inline m-cst--pagination d-flex justify-content-end gap-1'
              breakLabel='...'
              nextLabel=''
              onPageChange={handlePageClick}
              pageRangeDisplayed={pageRangeDisplayed}
              pageCount={data?.data?.pagination?.pageCount}
              previousLabel=''
              renderOnZeroPageCount={null}
              forcePage={filterDetails?.pageIndex - 1}
            />
          )}
        </div>
      </div>

      <ModelComponent
        show={modalSizeShow}
        className='modal-backdrop'
        modalsize={'md'}
        modalheaderclass={''}
        modeltitle={'Selected Category Size'}
        onHide={() => {
          setSizeSpecificationData(null)
          setSizeModalShow(false)
        }}
        btnclosetext={''}
        closebtnvariant={''}
        backdrop={'static'}
        formbuttonid={''}
      >
        <Table responsive className='align-middle table-list' bordered>
          {sizeSpecificationData &&
            sizeSpecificationData?.map((elem) => (
              <tbody key={elem.id}>
                <tr>
                  <td>
                    <th className='text-nowrap'>Size Type</th>
                  </td>
                  <td>{elem.sizeTypeName}</td>
                </tr>
                <tr>
                  <td>
                    <th className='text-nowrap'>Size Name</th>
                  </td>
                  <td>{elem.sizeName}</td>
                </tr>
                <tr>
                  <td>
                    <th className='text-nowrap'>Has price variant</th>
                  </td>
                  <td>{elem?.isAllowPriceVariant ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                  <td>
                    <th className='text-nowrap'>Allow in filter</th>
                  </td>
                  <td>{elem?.isAllowSizeInFilter ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                  <td>
                    <th className='text-nowrap'>Allow in title</th>
                  </td>
                  <td>{elem?.isAllowSizeInTitle ? 'Yes' : 'No'}</td>
                </tr>
                {elem?.isAllowSizeInTitle && (
                  <tr>
                    <td>
                      <th className='text-nowrap'>Title Sequence</th>
                    </td>
                    <td>
                      {elem?.titleSequenceOfSize
                        ? elem?.titleSequenceOfSize
                        : '0'}
                    </td>
                  </tr>
                )}
                <tr>
                  <td>
                    <th className='text-nowrap'>Allow As Comparision</th>
                  </td>
                  <td>{elem?.isAllowSizeInComparision ? 'Yes' : 'No'}</td>
                </tr>
              </tbody>
            ))}
        </Table>
      </ModelComponent>

      <ModelComponent
        show={modalAttributesShow}
        className='modal-backdrop'
        modalsize={'md'}
        modalheaderclass={''}
        modeltitle={'Selected Attributes'}
        onHide={() => {
          setAttributesModalData(null)
          setAttributesModalShow(false)
        }}
        btnclosetext={''}
        closebtnvariant={''}
        backdrop={'static'}
        formbuttonid={''}
      >
        <Table responsive className='align-middle table-list'>
          {/* <thead className="align-middle">
            <tr></tr>
          </thead> */}
          {attributesModalData && (
            <tbody key={attributesModalData.id}>
              <tr>
                <td>
                  <th className='text-nowrap'>Allow As Filter</th>
                </td>
                <td>
                  {attributesModalData?.isAllowColorsInFilter ? 'Yes' : 'No'}
                </td>
              </tr>
              <tr>
                <td>
                  <th className='text-nowrap'>Allow As Title</th>
                </td>
                <td>
                  {attributesModalData?.isAllowColorsInTitle ? 'Yes' : 'No'}
                </td>
              </tr>
              {attributesModalData?.isAllowColorsInTitle && (
                <tr>
                  <td>
                    <th className='text-nowrap'>Title Sequence</th>
                  </td>
                  <td>
                    {attributesModalData?.titleSequenceOfColor
                      ? attributesModalData?.titleSequenceOfColor
                      : '0'}
                  </td>
                </tr>
              )}
              <tr>
                <td>
                  <th className='text-nowrap'>Allow As Comparision</th>
                </td>
                <td>
                  {attributesModalData?.isAllowColorsInComparision
                    ? 'Yes'
                    : 'No'}
                </td>
              </tr>
            </tbody>
          )}
        </Table>
      </ModelComponent>

      <ModelComponent
        show={modalSpecificationShow}
        modalsize={'md'}
        modalheaderclass={''}
        modeltitle={`Specifications`}
        onHide={() => {
          setSpecificationData(null)
          setSpecificationModalShow(false)
        }}
        btnclosetext={''}
        closebtnvariant={''}
        backdrop={'static'}
        formbuttonid={''}
      >
        <Table responsive hover className='align-middle table-list'>
          <thead className='align-middle'>
            <tr>
              <th className='text-nowrap'>Name</th>
              <th className='text-nowrap'>Type</th>
              <th className='text-nowrap'>Type Value</th>
            </tr>
          </thead>
          <tbody>
            {specSpecificationData &&
              specSpecificationData.map((elem) => (
                <tr key={Math.floor(Math.random() * 1000000)}>
                  <td>{elem.specificationName}</td>
                  <td>{elem.specificationTypeName}</td>
                  <td
                    className={
                      elem.specificationTypeValueName ? '' : 'text-center'
                    }
                  >
                    {elem.specificationTypeValueName
                      ? elem.specificationTypeValueName
                      : '-'}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </ModelComponent>
    </>
  ) : (
    <NotFound />
  )
}

export default AssignCategory
